<template>
    <div class="all-item">
        <img :src="allGiftItemData.smallPic" alt class="g-img" />
        <div class="g-name" v-if="totalGiftLength!=1 || allGiftItemData.giftFlag != 1 ">{{ allGiftItemData.shortName || allGiftItemData.name }}</div>
        <slot v-if="$slots.specialInfo" name="specialInfo" />
    </div>
</template>
<script>
export default {
    name: 'allGiveGiftItem',
    props: ["allGiftItemData","totalGiftLength"]
}
</script>
<style lang="scss" scoped>
@import './index.scss'
</style>